// ---------------------------------------------------------------------------
// FAQ accordion
// ---------------------------------------------------------------------------
export function initFaq() {
    const items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    items.forEach((item) => {
        const head = item.querySelector('[data-faq-head]');
        head?.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');

            items.forEach((el) => {
                el.classList.remove('is-open');
                el.querySelector('[data-faq-head]')?.setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
                item.classList.add('is-open');
                head.setAttribute('aria-expanded', 'true');
            }
        });
    });
}
